
export class Collection {
  pid: string;
  title: string;
  titleCs: string;
  titleEn: string;
  description: string;
  descriptionCs: string;
  descriptionEn: string;
  count: number;
}
